import { render, staticRenderFns } from "./text-items-preview.vue?vue&type=template&id=bb084534&scoped=true"
import script from "./text-items-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./text-items-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./text-items-preview.vue?vue&type=style&index=0&id=bb084534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb084534",
  null
  
)

export default component.exports